module.exports = __webpack_public_path__ + "img/ic_close.9b1ec625.svg";